import { Box, Grid } from '@mui/material';
import { MFSubmitButton, MFTextField } from '../../lib/formik';
import { Formik, useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import {
  Distributor,
  getDistributors,
  getDistributorsResponse,
  SubDistributor,
} from '../../redux-store/actions';
import React, { useEffect, useState } from 'react';
import { RootStateType } from '../../redux-store/reducers';
import { updateApplication } from '../../redux-store/actions/application';
import { useHistory } from 'react-router';
import {
  DistributorMode,
  USER_ROLES,
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  POA_Authorized_signatory_can_Esign_Enable,
  poaValidationDate,
} from '../../utils/constant';
import { InfoDialog, SubHeading } from './components';
import { distributorsValidationSchema } from '../../utils/schema';
import {
  applicationComparison,
  applicationCreatedBy,
  isDistributorTypeCompany,
  labelForDistributorAdvisorRmNumber,
  statusRoleBased,
  checkIfApplicationIsIndividualPOA,
  checkValidationBasedOnDate,
} from '../../utils/utilityFunctions';
import { CountryCodesDropDown } from '../commonComponents';
import {
  DistributorListType,
  RMType,
  ApplicationProps,
  POAAuthorisedSignatories,
} from '../../redux-store/types/api-types';
import { getDistributorById } from '../../redux-store/actions/userManagement';
import { getDirectApplicableFunds } from '../../redux-store/actions/funds';
import { FundProps } from '../../redux-store/types/funds';
import { POAAuthorisedSignatoriesFragment } from '../NonIndividualInvestor/Authorised';
import { showError } from '../../redux-store/actions/auth';

type DistributorDetailsProps = {
  distributorName: string | null;
  distributorId: number | null;
  distributorEmail: string;
  distributorMobile: string;
  distributorCountryCode: string;
  distributorCountryNameAndCode: string;
  arnCode: string;
  distributorArnCode: string;
  rmName: string | null;
  loginType: string;
  firstName: string;
  empCode: string;
  email: string;
  subdistributorId: number | null;
  subdistributorName: string | null;
  subdistributorEmail: string | null;
  filledBy: string | null;
  mode: string;
  amcDistributorName: string;
  amcDistributorEmail: string;
  amcDistributorMobile: string;
  amcDistributorCountryCode: string;
  amcDistributorCountryNameCode: string;
};

type POAApplication = {
  authorisedSignatories: POAAuthorisedSignatories[];
  thrashold: number;
};

function GridItem({ children }: { children: React.ReactNode }) {
  return (
    <Grid item xs={12} sm={6}>
      {children}
    </Grid>
  );
}

const RMDetail = () => {
  return (
    <>
      <GridItem>
        <MFTextField name="firstName" label="RM Name" placeholder="Enter RM name" disabled={true} />
      </GridItem>
      <GridItem>
        <MFTextField
          name="email"
          label="RM Email ID"
          placeholder="Enter RM Email ID"
          disabled={true}
        />
      </GridItem>
      {/* <GridItem>
        <MFTextField
          name="empCode"
          label="Employee Code"
          placeholder="Enter Employee Code"
          disabled={true}
        />
      </GridItem> */}
    </>
  );
};

const DistributorDetail = ({
  distributor,
  values,
  distributorAdvisorLabel,
  application,
  authorisedSignatoriesPOA,
  setAuthorisedSignatoriesPOA,
}: // selectedDistributor,
// setSelectedDistributor,
{
  distributor: Distributor;
  values: DistributorDetailsProps;
  // selectedDistributor: SubDistributor[];
  // setSelectedDistributor: (distributor: SubDistributor[]) => void;
  distributorAdvisorLabel: string;
  application: ApplicationProps | null;
  authorisedSignatoriesPOA: POAApplication;
  setAuthorisedSignatoriesPOA: (e: POAApplication) => void;
}): JSX.Element => {
  const { role } = useSelector((store: RootStateType) => store.auth);
  const { setValues } = useFormikContext();
  const [open, setOpen] = useState(false);
  const [openDialog, setDialog] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogOpen = () => {
    setDialog(true);
  };
  const handleDialogClose = () => {
    setDialog(false);
  };
  const [mobileElementWidth, setMobileElementWidth] = useState(null);
  useEffect(() => {
    const mobileElement = document.getElementsByName('applicants.0.mobile');
    setMobileElementWidth(mobileElement[0]?.parentElement?.clientWidth as any);
  }, []);

  return (
    <>
      {/* {distributors.length > 0 ? ( */}
      {/* <> */}
      {/* {[USER_ROLES.RM].includes(role) && values.distributorId && (
        <Grid item xs={12} sx={{ textAlign: 'right' }}>
          <Button
            variant="contained"
            sx={{
              color: 'white',
              fontWeight: 500,
              fontSize: 14,
              py: 0.5,
              px: 3,
            }}
            onClick={handleDialogOpen}>
            clear
          </Button>
        </Grid>
      )} */}
      <GridItem>
        {/* <SearchableSelect
              name="distributorId"
              label="Distributor Name - Code *"
              items={distributors
                .sort((distributor1, distributor2) =>
                  (distributor1['name'] || '')
                    .toString()
                    .localeCompare((distributor2['name'] || '').toString())
                )
                .map((item) => ({
                  key: (item.name || 'NA') + ' - ' + (item.arnCode || 'NA'),
                  value: item.id,
                }))}
              onChange={({ target: { value } }) => {
                const distributorCode = distributors.find((item) => item.id === value);
                const { id = null, name } = distributorCode || {};
                setValues({
                  ...values,
                  distributorName: name,
                  distributorId: id,
                  subdistributorId: null,
                  subdistributorName: null,
                  subdistributorEmail: null,
                });
                setSelectedDistributor(
                  distributors.find((distributor) => distributor.id === value)?.subdistributors ||
                    []
                );
              }}
              disabled={[
                USER_ROLES.DISTRIBUTOR,
                USER_ROLES.INVESTOR,
                USER_ROLES.POAAPPROVER,
                USER_ROLES.SUBDISTRIBUTOR,
              ].includes(role)}
              searchFieldPlaceholder={'Search Distributor'}
            /> */}
        <MFTextField
          name="distributorArnCode"
          label={`${distributorAdvisorLabel || 'Distributor'} Code *`}
          placeholder={`Enter ${distributorAdvisorLabel || 'distributor'} code`}
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
        />
      </GridItem>
      <GridItem>
        <MFTextField
          name="distributorName"
          label={`${distributorAdvisorLabel || 'Distributor'} Name *`}
          placeholder={`Enter ${distributorAdvisorLabel || 'distributor'} name`}
          disabled={true}
        />
      </GridItem>

      <GridItem>
        <MFTextField name="mode" label="Mode" placeholder="Enter mode" disabled={true} />
      </GridItem>
      {/* {!!selectedDistributor?.length && (
            <>
              <GridItem>
                <SearchableSelect
                  name="subdistributorId"
                  label="Distributor's RM Name - Code *"
                  items={selectedDistributor
                    .sort((subDistributor1, subDistributor2) =>
                      (subDistributor1.user['firstName'] || '')
                        .toString()
                        .localeCompare((subDistributor2.user['firstName'] || '').toString())
                    )
                    .map((item) => ({
                      key: item.user.firstName + ' - ' + (item.distributors_RM_Code || 'NA'),
                      value: item.id,
                    }))}
                  onChange={({ target: { value } }) => {
                    const distributorCode = selectedDistributor.find((item) => item.id === value);
                    const { id = null, user } = distributorCode || {};
                    const { email } = user || {};
                    setValues({
                      ...values,
                      subdistributorId: id,
                      subdistributorEmail: email,
                    });
                  }}
                  disabled={[
                    USER_ROLES.DISTRIBUTOR,
                    USER_ROLES.INVESTOR,
                    USER_ROLES.POAAPPROVER,
                    USER_ROLES.SUBDISTRIBUTOR,
                  ].includes(role)}
                  searchFieldPlaceholder={"Search Distributor's RM"}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorName"
                  label="Distributor's RM Name *"
                  placeholder="Enter Distributor name"
                  disabled={true}
                />
              </GridItem>
              <GridItem>
                <MFTextField
                  name="subdistributorEmail"
                  label="Distributor's RM Email *"
                  placeholder="Enter Distributor email"
                  disabled={true}
                />
              </GridItem>
            </>
          )} */}
      {/* <GridItem>
        <MFTextField name="filledBy" label="Filled by" placeholder="Enter filled by" />
        <Typography
          component="span"
          sx={{ position: 'relative', left: 64, bottom: { xs: 85, md: 91 } }}>
          <InfoOutlinedIcon color="info" fontSize="small" onClick={handleOpen} />
        </Typography>
      </GridItem> */}
      {isDistributorTypeCompany(distributor) ? (
        <>
          <GridItem>
            <MFTextField
              name="subdistributorName"
              label="Filled By"
              placeholder="Enter filled by"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="subdistributorEmail"
              label="Email"
              placeholder="Enter email"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="amcDistributorName"
              label={`${distributorAdvisorLabel || 'Distributor'} RM Name *`}
              placeholder={`Enter ${distributorAdvisorLabel || 'distributor'} rm name`}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="amcDistributorEmail"
              label={`${distributorAdvisorLabel || 'Distributor'} RM Email *`}
              placeholder={`Enter ${distributorAdvisorLabel || 'distributor'} rm email`}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="amcDistributorMobile"
              label={`${labelForDistributorAdvisorRmNumber(
                distributorAdvisorLabel
              )} Phone Number *`}
              placeholder={`Enter ${labelForDistributorAdvisorRmNumber(
                distributorAdvisorLabel
              ).toLowerCase()} phone number`}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`amcDistributorCountryNameCode`}
                  value={values.amcDistributorCountryNameCode}
                />
              }
            />
          </GridItem>

          {application &&
            application?.poaauthorisedsignatories?.length >= 0 &&
            checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
            checkIfApplicationIsIndividualPOA(application) &&
            POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE && (
              <>
                <SubHeading>Authorised Signatories</SubHeading>
                <POAAuthorisedSignatoriesFragment
                  onChange={(e) => setAuthorisedSignatoriesPOA(e)}
                  values={authorisedSignatoriesPOA}
                />
              </>
            )}
        </>
      ) : (
        <>
          <GridItem>
            <MFTextField
              name="distributorEmail"
              label="Email"
              placeholder="Enter Email"
              disabled={true}
            />
          </GridItem>
          <GridItem>
            <MFTextField
              name="distributorMobile"
              label={`${labelForDistributorAdvisorRmNumber(
                distributorAdvisorLabel
              )} Phone Number *`}
              placeholder={`Enter ${labelForDistributorAdvisorRmNumber(
                distributorAdvisorLabel
              ).toLowerCase()} rm phone number`}
              disabled={true}
              startAdornment={
                <CountryCodesDropDown
                  ElementWidth={mobileElementWidth && mobileElementWidth}
                  name={`distributorCountryNameAndCode`}
                  value={values.distributorCountryNameAndCode}
                  disabled={true}
                />
              }
            />
          </GridItem>
        </>
      )}
      <GridItem>
        <MFTextField
          name="rmName"
          label="ASK RM Name"
          placeholder="Enter ASK RM name"
          disabled={[USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)}
          // disabled={true}
        />
      </GridItem>
      <InfoDialog
        onClose={handleClose}
        open={open}
        content={'Please add the Name of the Subdistributor RM.'}
      />
    </>
    // <Grid
    //   xs={12}
    //   sm={12}
    //   sx={{
    //     fontSize: 18,
    //     fontWeight: 500,
    //     color: 'rgb(97, 209, 214)',
    //     display: 'flex',
    //     alignItems: 'center',
    //     textAlign: 'center',
    //     justifyContent: 'center',
    //     mt: { lg: 9, xs: 9 },
    //     mb: 2.9,
    //     ml: { xs: 3 },
    //   }}>
    //   No distributor mapped under this RM
    // </Grid>
    //  <ConfirmationDialog
    //   message={`Are you sure you want to clear RM/Distributor details ?`}
    //   open={openDialog}
    //   setOpen={handleDialogClose}
    //   onSave={() => {
    //     handleDialogClose();
    //     setValues({
    //       ...values,
    //       distributorName: '',
    //       distributorId: null,
    //       subdistributorId: null,
    //       subdistributorName: '',
    //       subdistributorEmail: '',
    //     });
    //     setSelectedDistributor([]);
    //   }}
    //   onCancel={handleDialogClose}
    // />
    // </>
  );
};

export default function DistributorDetails(): JSX.Element {
  const dispatch = useDispatch();
  const history = useHistory();
  const [distributors, setDistributors] = useState<Distributor[]>([]);
  const { application } = useSelector((store: RootStateType) => store.application);
  const { role } = useSelector((store: RootStateType) => store.auth);
  const [selectedDistributor, setSelectedDistributor] = useState<SubDistributor[]>([]);
  const {
    distributor,
    rm,
    subdistributorId = null,
    subDistributor,
    filledBy = '',
    rm_id,
    distributorArnCode,
    rmName = '',
  } = application || {};

  const {
    name,
    id,
    arnCode,
    mode = '',
    user: distributorUser = {},
  } = distributor || {
    arnCode: '',
    name: '',
    id: null,
    user: { email: '', phone: '', countryCode: '', countryNameAndCode: '' },
  };

  const {
    empCode,
    user: { email: RMEmail = '', firstName: RMFirstName = '' },
  } = rm || { empCode: '', user: { email: '' } };

  const {
    user: { firstName: subdistributorName, email: subdistributorEmail },
  } = subDistributor || { user: { firstName: '', email: '' } };

  const initialValues: DistributorDetailsProps = {
    distributorId: id,
    distributorName: name,
    distributorEmail: distributorUser?.email || '',
    distributorMobile: distributorUser?.phone || '',
    distributorCountryCode: distributorUser?.countryCode || '+91',
    distributorCountryNameAndCode: distributorUser?.countryNameAndCode || 'India: +91',
    arnCode: arnCode || 'N/A',
    distributorArnCode: distributorArnCode || arnCode || 'N/A',
    rmName,
    loginType: id ? USER_ROLES.DISTRIBUTOR : USER_ROLES.RM,
    empCode,
    email: RMEmail,
    firstName: RMFirstName,
    subdistributorId: subdistributorId === null ? subdistributorId : Number(subdistributorId),
    subdistributorName,
    subdistributorEmail,
    filledBy,
    amcDistributorName: application?.amcDistributorName || '',
    amcDistributorEmail: application?.amcDistributorEmail || '',
    amcDistributorMobile: application?.amcDistributorMobile || '',
    mode: DistributorMode[mode],
    amcDistributorCountryCode: application?.amcDistributorCountryCode || '+91',
    amcDistributorCountryNameCode: application?.amcDistributorCountryNameCode || 'India: +91',
  };
  const [authorisedSignatoriesPOA, setAuthorisedSignatoriesPOA] = useState<POAApplication>({
    authorisedSignatories: application?.poaauthorisedsignatories || [],
    thrashold: application?.requiredAuthorisedSignatory || 0,
  });

  useEffect(() => {
    let isComponentActive = true;
    (async function () {
      try {
        if (Object.keys(application || {}).length && role === USER_ROLES.RM) {
          const res = (await dispatch(
            getDistributors({ isActive: true })
          )) as unknown as getDistributorsResponse;
          const { distributors = [] } = res || {};
          const updatedDistributor =
            application?.distributor_id && !application.distributor.isActive
              ? [
                  ...distributors,
                  {
                    ...application.distributor,
                    subdistributors: [application.subDistributor].filter((ele) => ele),
                  } as Distributor,
                ]
              : distributors;
          if (isComponentActive) {
            const updateSubdistributor = (
              application?.distributor_id &&
              application?.distributor.isActive &&
              application?.subdistributorId &&
              !application.subDistributor?.isActive
                ? [
                    ...(updatedDistributor.find((distributor) => distributor.id === id)
                      ?.subdistributors || []),
                    { ...application.subDistributor },
                  ]
                : updatedDistributor.find((distributor) => distributor.id === id)
                    ?.subdistributors || []
            ).filter((ele) => ele);
            setSelectedDistributor(updateSubdistributor as unknown as SubDistributor[]);
            setDistributors(updatedDistributor as unknown as Distributor[]);
          }
        } else {
          const { distributor, subDistributor } = application || {};
          setDistributors(distributor ? [distributor as Distributor] : []);
          setSelectedDistributor(
            subDistributor
              ? [{ ...subDistributor, id: Number(subDistributor.id) } as SubDistributor]
              : []
          );
        }
        setAuthorisedSignatoriesPOA({
          authorisedSignatories: application?.poaauthorisedsignatories || [],
          thrashold: application?.requiredAuthorisedSignatory || 0,
        });
      } catch (e: unknown) {
        console.error((e as Error).message);
      }
    })();
    return () => {
      isComponentActive = false;
    };
  }, [application]);

  const onSubmit = async (values: DistributorDetailsProps) => {
    try {
      const {
        distributorId,
        subdistributorId,
        filledBy,
        rmName,
        amcDistributorName,
        amcDistributorEmail,
        amcDistributorMobile,
        amcDistributorCountryNameCode,
        distributorArnCode,
      } = values;
      const {
        id,
        applicant1ReferenceId,
        currentStep = null,
        status,
        hasPOA,
        distributor_id,
      } = application || {};

      if (
        application &&
        checkValidationBasedOnDate(application.createdAt || '', poaValidationDate) &&
        checkIfApplicationIsIndividualPOA(application) &&
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
      ) {
        const getCanEsignCount = authorisedSignatoriesPOA.authorisedSignatories?.filter(
          (item) => item.canEsign
        );
        if (!authorisedSignatoriesPOA.authorisedSignatories?.length) {
          throw 'Please add Authorised Signatories';
        }
        if (!getCanEsignCount.length) {
          throw 'Please Select a member for E-Sign';
        }
        if (getCanEsignCount.length < authorisedSignatoriesPOA.thrashold) {
          throw 'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories';
        }
      }

      const Poa_can_esign =
        POA_Authorized_signatory_can_Esign_Enable &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE
          ? {
              poaauthorisedsignatories:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.authorisedSignatories
                  : application?.poaauthorisedsignatories,
              requiredAuthorisedSignatory:
                application && checkIfApplicationIsIndividualPOA(application)
                  ? authorisedSignatoriesPOA.thrashold
                  : application?.requiredAuthorisedSignatory,
            }
          : {};

      const updatedApplication = {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        ...application!,
        ...Poa_can_esign,
        distributor_id: distributorId,
        amcDistributorName,
        amcDistributorEmail,
        amcDistributorMobile,
        amcDistributorCountryCode: amcDistributorCountryNameCode?.split(':')[1].trim(),
        amcDistributorCountryNameCode,
        subdistributorId: subdistributorId ? subdistributorId.toString() : subdistributorId,
        distributorArnCode,
        filledBy: filledBy,
        rmName: rmName,
      };

      const checkApplication = applicationComparison(application, {
        ...updatedApplication,
        currentStep: currentStep === null ? 1 : currentStep,
      });
      let restSchemePlan = {};
      const isDistributorExists =
        !distributorId &&
        application?.distributor_id &&
        (application?.schemeId || application?.planId);
      if (distributorId || isDistributorExists) {
        let getPlanId: any[] = [];
        if (Number(distributorId) !== Number(application?.distributor_id) && distributorId) {
          getPlanId = (
            (await dispatch(getDistributorById(distributorId))) as unknown as DistributorListType
          )?.planDetails.planIds;
        } else if (isDistributorExists) {
          (
            (await dispatch(getDirectApplicableFunds({ isActive: true }))) as unknown as FundProps[]
          )?.map((fund) => {
            getPlanId.push(
              ...fund.plans?.filter((fund) => fund.isApplicableForDirect)?.map((plan) => plan.id)
            );
            return fund;
          });
        }
        if (
          application?.planId &&
          getPlanId?.length > 0 &&
          !getPlanId.map((ele) => ele?.toString()).includes(application?.planId?.toString())
        ) {
          //reset whatEver Fields used in investmentPayment details section
          restSchemePlan = {
            schemeId: null,
            planId: null,
            commitmentAmount: 0,
            setupFeePercentage: 0,
            managementFeesRate: 0,
            contributionChequeAmount: 0,
            // taxRate: null,
            // drawDownNumber: null,
            setupFeeAmount: null,
            setupFeeGST: null,
            totalSetupFee: null,
            setupFeeTDS: null,
            netSetupFeeLessTDS: null,
            totalAmountPayable: null,
          };
        }
      }
      if (id && !checkApplication) {
        await dispatch(
          updateApplication({
            body: {
              // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
              ...updatedApplication,
              ...restSchemePlan,
              status: statusRoleBased(role, application),
              currentStep: 1,
              //currentStep === null ? 1 : currentStep
            },
            applicationId: id,
          })
        );
        history.push('contributor-details', { id, applicant1ReferenceId });
      } else if (checkApplication) {
        history.push('contributor-details', { id, applicant1ReferenceId });
      }
    } catch (e) {
      typeof e === 'string' && dispatch(showError(e));
      console.error((e as Error).message);
    }
  };

  const distributorAdvisorLabel =
    applicationCreatedBy(
      application?.rm as RMType,
      application?.distributor as Distributor,
      application?.subDistributor as SubDistributor,
      application?.createdBy as string,
      false
    ) || '';

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={distributorsValidationSchema(
        selectedDistributor,
        distributors,
        distributorAdvisorLabel
      )}
      onSubmit={onSubmit}
      enableReinitialize={true}>
      {({ handleSubmit, values }) => (
        <Box component="form" noValidate onSubmit={handleSubmit}>
          {/* <Notes
            displayContent={
              'This section specifies whether the application is from an RM/Distributor’s RM.'
            }
          /> */}
          <Grid container rowSpacing={2} columnSpacing={5}>
            {/* {[USER_ROLES.RM].includes(role) && (
              <Grid item xs={12}>
                <UseRadioGroup
                  formLabel=""
                  name={`loginType`}
                  items={[
                    { label: 'Direct', value: USER_ROLES.RM },
                    { label: 'Distributor', value: USER_ROLES.DISTRIBUTOR },
                  ]}
                />
              </Grid>
            )} */}
            {
              // ![USER_ROLES.DISTRIBUTOR, USER_ROLES.SUBDISTRIBUTOR, USER_ROLES.POAAPPROVER].includes(
              //   role
              // ) &&
              values.loginType === USER_ROLES.RM ? (
                <RMDetail />
              ) : (
                <DistributorDetail
                  // distributors={distributors}
                  distributor={application?.distributor as Distributor}
                  values={values}
                  // selectedDistributor={selectedDistributor}
                  // setSelectedDistributor={(subdistributors) =>
                  //   setSelectedDistributor(subdistributors)
                  // }
                  distributorAdvisorLabel={distributorAdvisorLabel}
                  application={application}
                  authorisedSignatoriesPOA={authorisedSignatoriesPOA}
                  setAuthorisedSignatoriesPOA={(e) => setAuthorisedSignatoriesPOA(e)}
                />
              )
            }
          </Grid>
          <Box sx={{ width: '100%', maxWidth: '350px', mx: 'auto', mt: 5 }}>
            <MFSubmitButton label="Next" />
          </Box>
        </Box>
      )}
    </Formik>
  );
}
